(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import storage from "../../store/localStorage";

const useUser = () => {
  const [user, setUser] = useState({
    id: storage.get("userId") || null
  });
  useEffect(() => {
    if (!user.id) {
      const userId = uuidv4();
      setUser({
        id: userId
      });
      storage.set("userId", userId);
    }
  }, [user]);
  return [user];
};

__signature__(useUser, "useState{[user, setUser]({ id: storage.get(\"userId\") || null })}\nuseEffect{}");

const _default = useUser;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useUser, "useUser", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/User/hooks.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/User/hooks.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();